import {
    clearPermissionsCache,
    fetchPermissionsV2,
} from '../../services/permissions/permissionsV2.service';
import { getSilentToken } from '../../services/tokenUtils';

const CUSTOMER_ID_KEY = 'cop:customer-id';

const prewarm = (customerId: string): void => {
    fetchPermissionsV2(customerId); // fire & forget — fills module-level permissionsQueryClient cache
};

export const initPermissionsPrewarm = (): void => {
    const w = window as unknown as { Granite?: { author?: unknown } };
    if (w.Granite?.author) return; // skip AEM author mode

    // Case 1: token + customerId already available (cached token, returning user)
    if (getSilentToken()) {
        const customerId = sessionStorage.getItem(CUSTOMER_ID_KEY);
        if (customerId) {
            prewarm(customerId);
        }
    }

    // Case 2: token not ready yet — wait for silent token flow to complete
    // 'cop:token-acquired' is fired by triggerOnPageLoad.ts
    document.addEventListener(
        'cop:token-acquired',
        () => {
            const customerId = sessionStorage.getItem(CUSTOMER_ID_KEY);
            if (customerId) prewarm(customerId);
        },
        { once: true },
    );

    // Case 3: customer switches account (select account page)
    // 'cop:customer-ready' is fired by persistCustomerSelection() in userRoleRedirect.ts
    window.addEventListener('cop:customer-ready', (e: Event) => {
        const newCustomerId = (e as CustomEvent<{ customerId: string }>).detail?.customerId;
        if (!newCustomerId) return;

        // Clear old customer's V2 cache before pre-warming the new one.
        // persistCustomerSelection() only clears the old V1 key ('cop:permissions') —
        // we must clear V2 here to prevent stale entries accumulating in sessionStorage.
        const oldCustomerId = sessionStorage.getItem(CUSTOMER_ID_KEY);
        if (oldCustomerId && oldCustomerId !== newCustomerId) {
            clearPermissionsCache(oldCustomerId);
        }

        prewarm(newCustomerId);
    });
};
